<script>
import appbarMixin from '@/v-shop/mixins/appbarMixin'

export default {
	mixins: [appbarMixin],
	props: {
		hideText: Boolean,
		iconColor: String,
		btnClass: String,
		iconSize: [String, Number],
		iconOptions: Object,
	},
	computed: {
		cIconOptions() {
			return this.iconOptions?.iconType ? this.iconOptions : { iconType: 'default', icon: 'mdi-account' }
		},
	},
}
</script>

<template>
	<div>
		<v-btn
			v-if="user && $b.td"
			text
			:class="[btnClass, !hideText && 'mr-2', 'appbar__buttons_btn']"
			:to="{ name: 'user.account' }"
			:color="iconColor || $vars.basetext"
		>
			<v-icon :size="iconSize" class="btn" :class="!hideText && 'mr-1'"> mdi-account</v-icon>
			<span v-if="!hideText" class="font-1" :style="`color: ${iconColor || $vars.basetext}`">{{
				user.firstname
			}}</span>
		</v-btn>
		<v-btn
			v-if="!user && $b.td"
			text
			:class="[btnClass, !hideText && 'mr-2']"
			@click="showLoginDrawer"
			:color="iconColor || $vars.basetext"
			:loading="loginLoading"
		>
			<CustomIcon v-bind="cIconOptions" :icon-attrs="{ size: iconSize }" :class="!hideText && 'mr-1'" />
			<span v-if="!hideText" class="font-1">Ingresar</span>
		</v-btn>
	</div>
</template>

